import { useTranslation } from 'react-i18next'
import { M_Fieldset } from 'src/M_Components'
import { ShipmentChargesFormField } from './ShipmentChargesFormField'

export const ShipmentChargesDetails = ({ dataState, setDataState, disabled }) => {
    const { t } = useTranslation()

    const goalOptions = [
        { label: 'Line', value: 'L' },
        { label: 'Agent Only', value: 'A' },
        { label: 'Commission', value: 'O' },
    ]

    const exchangeRateOptions = [
        { label: 'Sale', value: 'S' },
        { label: 'Average', value: 'A' },
        { label: 'Buy', value: 'B' },
    ]

    const payableHowOptions = [
        { label: 'Prepaid', value: 'P' },
        { label: 'Collect', value: 'C' },
        { label: 'Prep. Else', value: 'Q' },
        { label: 'Coll. Else', value: 'D' },
        { label: 'Other', value: 'O' },
    ]

    const payingCompanyOptions = [
        { label: 'Invoice', value: 'I' },
        { label: 'Client', value: 'C' },
        { label: 'Shipper', value: 'S' },
        { label: 'Consignee', value: 'G' },
        { label: 'Notify', value: 'N' },
        { label: 'Agent', value: 'A' },
        { label: 'Feeder', value: 'F' },
        { label: 'Other', value: 'O' },
        { label: 'Other - Foreign Currency', value: 'E' },
    ]

    // Paying Code só é editável quando PayingCompany = Other (O) ou Other - Foreign Currency (E)
    const payingAccountEnabled = ['O', 'E'].includes(dataState.PayingCompany)

    const onPayingCompanyChange = (_data, _fields, obj) => {
        const value = (obj && obj.value) || ''
        setDataState(prev => ({
            ...prev,
            PayingCompany: value,
            ...(!['O', 'E'].includes(value) && {
                PayingCompanyAccountCode: '',
                PayingCompanyAccountName: '',
                PayingCompanyAccountId: null,
            }),
        }))
    }

    const rows = [
        [
            {
                display: t('ServiceCode'), required: true, code: 'ServiceTypeCode', type: 'foreignKey',
                entity: 'ServiceType', tableLabel: t('ServiceType'), filterField: 'code', labelFields: ['ServiceCode'],
                fields: [{ key: 'ServiceCode', value: 'ServiceTypeCode' }, { key: 'ServiceName', value: 'ServiceTypeName' }, { key: 'Id', value: 'ServiceTypeId' }],
                favoritesFieldName: 'ServiceCode', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'ServiceTypeCode', favoritesIdKey: 'ServiceTypeId',
            },
            { display: t('ServiceName'), code: 'ServiceTypeName', type: 'disabled', grow: true },
        ],
        [
            { display: t('Goal'), required: true, code: 'Goal', type: 'select', options: goalOptions },
            { display: t('ExchangeRate'), required: true, code: 'ExchangeRate', type: 'select', options: exchangeRateOptions },
            { display: t('PayableHow'), required: true, code: 'PayableHow', type: 'select', options: payableHowOptions },
        ],
        [
            {
                display: t('PayingLocationCode'), code: 'PayingLocationCode', type: 'foreignKey',
                entity: 'Location', filterField: 'LocationCode', labelFields: ['LocationCode'],
                fields: [{ key: 'LocationCode', value: 'PayingLocationCode' }, { key: 'LocationName', value: 'PayingLocationName' }, { key: 'Id', value: 'PayingLocationId' }],
                favoritesFieldName: 'PayingLocationCode', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'PayingLocationCode', favoritesIdKey: 'PayingLocationId',
            },
            { display: t('LocationName'), code: 'PayingLocationName', type: 'disabled', grow: true },
        ],
        [
            {
                display: t('InvoicingCode'), code: 'InvoiceCompanyCode', type: 'foreignKey',
                entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'],
                fields: [{ key: 'AccountCode', value: 'InvoiceCompanyCode' }, { key: 'AccountName', value: 'InvoiceCompanyName' }, { key: 'Id', value: 'InvoiceCompanyId' }],
                favoritesFieldName: 'InvoicingCode', favoritesGroupName: 'ShipmentCharges', favoritesVarKey: 'InvoiceCompanyCode', favoritesIdKey: 'InvoiceCompanyId',
            },
            { display: t('InvoicingName'), code: 'InvoiceCompanyName', type: 'disabled', grow: true },
        ],
    ]

    return (
        <M_Fieldset
            labelInside
            label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '20px', marginLeft: '10px' }}>
                    <i className='pi pi-list' style={{ fontSize: '18px' }} />
                    {t('Details')}
                </div>
            }
            elements={
                <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                    {rows.map((row, rowIndex) => (
                        <div key={rowIndex} style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                            {row.map((field, colIndex) => (
                                <ShipmentChargesFormField
                                    key={colIndex}
                                    fields={field}
                                    index={rowIndex * 10 + colIndex}
                                    data={dataState}
                                    setData={setDataState}
                                    options={field.options}
                                    disabled={disabled}
                                />
                            ))}
                        </div>
                    ))}

                    {/* PayingCompany row — PayingCode só activo em Other / Other-Foreign */}
                    <div style={{ display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <ShipmentChargesFormField
                            fields={{ display: t('PayingCompany'), required: true, code: 'PayingCompany', type: 'select', options: payingCompanyOptions }}
                            index={50}
                            data={dataState}
                            setData={setDataState}
                            options={payingCompanyOptions}
                            returnFunc={onPayingCompanyChange}
                            disabled={disabled}
                        />
                        <ShipmentChargesFormField
                            fields={{
                                display: t('PayingCode'), code: 'PayingCompanyAccountCode', type: 'foreignKey',
                                entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'],
                                fields: [{ key: 'AccountCode', value: 'PayingCompanyAccountCode' }, { key: 'AccountName', value: 'PayingCompanyAccountName' }, { key: 'Id', value: 'PayingCompanyAccountId' }],
                            }}
                            index={51}
                            data={dataState}
                            setData={setDataState}
                            disabled={disabled || !payingAccountEnabled}
                        />
                        <ShipmentChargesFormField
                            fields={{ display: t('PayingName'), code: 'PayingCompanyAccountName', type: 'disabled', grow: true }}
                            index={52}
                            data={dataState}
                            setData={setDataState}
                            disabled={disabled}
                        />
                    </div>
                </div>
            }
        />
    )
}
